import { Route, Routes, Navigate } from 'react-router-dom'

/////////////
// Wrapper //
/////////////

import { MasterLayout } from '_metronic/layout/MasterLayout'

////////////
// Routes //
////////////

import DashboardRoutes from './Routes/Dashboard'
import SaleOrderRoutes from './Routes/SaleOrder'
import SurveyRoutes from './Routes/Survey'
import UsersRoutes from './Routes/Users'
import ProjectRoutes from './Routes/Project'
// import IssueRoutes from './Routes/Issue'
// import LabelRoutes from './Routes/Label'
import ShippingRoutes from './Routes/Shipping'
import MaintenanceRoutes from './Routes/Maintenance'
// import DailyReportRoutes from './Routes/DailyReport'
import RequestRoutes from './Routes/Request'
import MachineRoutes from './Routes/Machine'
import PileRoutes from './Routes/Pile'
import ExternalApiAuditLogRoutes from './Routes/ExternalApiAuditLog'
import ReceiveScanLogRoutes from './Routes/ReceiveScanLog'

///////////
// Views //
///////////

import Home from 'Presentation/Views/Home/View'
import ResetPasswordView from 'Presentation/Views/ResetPassword/View'
import PrintView from 'Presentation/Views/Print/View'
import PileItemImagePrint from 'Presentation/Views/Project/PileItemImagePrint/View'
import { Logout } from 'Presentation/Views/Auth'
import { Error404 } from 'Presentation/Views/Error/404/View'

import { useAppStore } from 'Store/App'
import { shallow } from 'zustand/shallow'

const PrivateRoutes = () => {
  const prevPage = useAppStore(state => state.prevPage, shallow)

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to={prevPage ?? '/home'} />} />

        <Route path='home' element={<Home />} />
        <Route path='reset-password' element={<ResetPasswordView />} />
        <Route path='sign-out' element={<Logout />} />

        <Route path='dashboard/*' element={<DashboardRoutes />} />
        <Route path='project/*' element={<ProjectRoutes />} />
        <Route path='sale-order/*' element={<SaleOrderRoutes />} />
        <Route path='survey/*' element={<SurveyRoutes />} />
        <Route path='shipping-request/*' element={<ShippingRoutes />} />
        <Route path='request/*' element={<RequestRoutes />} />
        {/* <Route path='label/*' element={<LabelRoutes />} />
        <Route path='issue/*' element={<IssueRoutes />} /> */}
        <Route path='maintenance/*' element={<MaintenanceRoutes />} />
        {/* <Route path='daily-report/*' element={<DailyReportRoutes />} /> */}
        <Route path='users/*' element={<UsersRoutes />} />
        <Route path='machine/*' element={<MachineRoutes />} />
        <Route path='pile/*' element={<PileRoutes />} />
        <Route path='external-api-audit-log/*' element={<ExternalApiAuditLogRoutes />} />
        <Route path='receive-scan-log/*' element={<ReceiveScanLogRoutes />} />
      </Route>

      <Route path='print' element={<PrintView />} />
      <Route
        path='project/:id/pile-executed-list/:pileHoleId/print'
        element={<PileItemImagePrint />}
      />
      <Route path='*' element={<Error404 />} />
    </Routes>
  )
}

export { PrivateRoutes }
